// Small helpers shared by every module: DOM, escaping, numbers, interpolation, seeded random numbers, distances.
export var DEG = Math.PI / 180;
export var reduced = false; try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

export function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
export function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
export function tipAttr(html) { return ' data-tip="' + esc(html) + '"'; }
export var fmtN = function (v, d) { return (Object.is(v, -0) ? 0 : v).toLocaleString('en-GB', { minimumFractionDigits: d, maximumFractionDigits: d }); };
export function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
export function lerp(a, b, t) { return a + (b - a) * t; }
export function smooth(t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); }

// piecewise-linear lookup in [[x, y], ...] (x ascending)
export function interp(tab, x) {
  if (x <= tab[0][0]) return tab[0][1];
  for (var i = 1; i < tab.length; i++) if (x <= tab[i][0]) { var a = tab[i - 1], b = tab[i]; return a[1] + (b[1] - a[1]) * (x - a[0]) / (b[0] - a[0]); }
  return tab[tab.length - 1][1];
}

// seeded random numbers (mulberry32) and a stable hash of a string
export function hashStr(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
export function rng(seed) {
  var a = seed >>> 0;
  return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; };
}
export function gauss(r) { var u = Math.max(1e-9, r()), v = r(); return Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v); }

export function haversineKm(la1, lo1, la2, lo2) {
  var a = Math.sin((la2 - la1) * DEG / 2), b = Math.sin((lo2 - lo1) * DEG / 2);
  return 2 * 6371 * Math.asin(Math.sqrt(a * a + Math.cos(la1 * DEG) * Math.cos(la2 * DEG) * b * b));
}

// standard normal CDF (for ranges)
export function sum(a) { var s = 0; for (var i = 0; i < a.length; i++) s += a[i]; return s; }
export function mean(a) { return a.length ? sum(a) / a.length : 0; }
export function quantile(sorted, q) { if (!sorted.length) return NaN; var i = (sorted.length - 1) * q, lo = Math.floor(i), hi = Math.ceil(i); return sorted[lo] + (sorted[hi] - sorted[lo]) * (i - lo); }

// width of an element's content box in CSS pixels (charts are drawn at this size so their text is not scaled)
export function innerW(node, min, max) { var cs = getComputedStyle(node), w = node.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight); return Math.round(Math.max(min, Math.min(max, w || min))); }
// lower-case the first letter of a name for use inside a sentence, but keep acronyms (HSS, 3P) and single letters (blade B)
export function lc1(x) { return /^[A-Z][a-z]/.test(x) ? x.charAt(0).toLowerCase() + x.slice(1) : x; }
